import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TslSessionService } from './tsl-session.service';
export interface TslPage {
  number: number;
  size: number;
  totalItems?: number;
}

export interface Page<T> {
  items: T[];
  page: PageInfo;
}

export const defaultPage: Page<any> = {
  items: [],
  page: {
    number: 0,
    size: 20,
    totalItems: 0
  }
};

export interface PageInfo {
  number: number;
  size: number;
  totalItems: number;
}

interface HttpOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  observe?: 'body';
  params?:
    | HttpParams
    | {
        [param: string]: string | string[];
      };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
}

export const TSL_API_HOST = new InjectionToken<string>('TSL_API_HOST');

@Injectable({
  providedIn: 'root'
})
export class TslApiService {
  private http = inject(HttpClient);
  private session = inject(TslSessionService);
  private apiHost = inject(TSL_API_HOST);

  private getBaseOptions(): HttpOptions {
    const options: HttpOptions = {};
    if (this.session.isSignedIn) {
      options.headers = {
        Authorization: 'Bearer ' + this.session.accessToken
      };
    }
    return options;
  }

  get<T>(url: string, params?: any): Observable<T> {
    const options = this.getBaseOptions();
    if (params) {
      options.params = params;
    }
    return this.http.get<T>(this.apiHost + url, options);
  }

  post<T>(url: string, data: any): Observable<T> {
    const options = this.getBaseOptions();
    return this.http.post<T>(this.apiHost + url, data, options);
  }

  put<T>(url: string, data: any): Observable<T> {
    const options = this.getBaseOptions();
    return this.http.put<T>(this.apiHost + url, data, options);
  }

  delete<T>(url: string, params?: any): Observable<T> {
    const options = this.getBaseOptions();
    if (params) {
      options.params = params;
    }
    return this.http.delete<T>(this.apiHost + url, options);
  }
}
